<template>
  <div class="more-page">
    <CreekStripeDonatePanelKKRN
      v-if="donateConfig"
      :config="donateConfig"
    />
  </div>
</template>

<script>

import axios from 'axios'
import yaml from 'js-yaml'
import { marked } from 'marked'

import CreekStripeDonatePanelKKRN from '@creek-website-toolkit/components/panels/StripeDonatePanelKKRN'


const toCamel = (o) => {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function(value) {
        if (typeof value === "object") {
          value = toCamel(value)
        }
        return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (
          origKey
            .replace(/ /g, '')
            .charAt(0)
            .toLowerCase()
          + origKey.replace(/ /g, '').slice(1) || origKey
        ).toString()
        value = o[origKey]
        if (
          value instanceof Array 
          || (value !== null && value.constructor === Object)
        ) {
          value = toCamel(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}

export default {
  name: 'DonatePage',
  components: {
    CreekStripeDonatePanelKKRN
  },
  data(){
    return {
      donateConfig: null
    }
  },
  computed: {

  },
  async created(){

    const response = await axios.get('https://kkrn.creek.fm/themes/get_options')

    X(response.data)

    // this.donateConfig = yaml.load(response.data.data)




    const dataWithYAML = response.data

    const yamlRaw = dataWithYAML.data

    const yamlParsed = yaml.load(yamlRaw)

    console.log(yamlParsed)
    console.log(toCamel)

    const configFormatted = toCamel(yamlParsed)

    console.log(toCamel(yamlParsed))

    let configToFix = configFormatted.donationPage
    let configFixed = configFormatted.donationPage

    console.log(configToFix)
    console.log(configFixed)

    const markdownTextFields = [
      'recurringWhy',
      'introMore',
      'intro',
    ]

    console.log(markdownTextFields)

    for (var i = markdownTextFields.length - 1; i >= 0; i--) {
      
      const m = markdownTextFields[i]
      
      console.log(m)
      console.log(configToFix.text[m])

      console.log(marked.parse(configToFix.text[m]))
      
      configFixed.text[m] = marked(
        configToFix.text[m]
      )

    }

    console.log(configFixed)

    this.donateConfig = JSON.parse(JSON.stringify(configFixed))




    X('siuhdasdasd')
    X(this.donateConfig)

  }
}

</script>
